/* ShopDoorMate: Delivery Dash mini-game. Pure canvas, no tracking, no data collected. */
(function () {
  'use strict';
  const W = 360, H = 600, GROUND = 548, GAME_SECONDS = 40;
  const TITLES = [
    [0, 'Porch Rookie', 'Everyone starts somewhere. Usually the lawn.'],
    [300, 'Curbside Cadet', 'The food is getting closer to the door!'],
    [700, 'Doorstep Dynamo', 'Your driver would give you 5 stars.'],
    [1200, 'Porch Pro', 'Fries still hot. Drinks still upright.'],
    [1800, 'Drop Zone Hero', 'Dogs, cats and trees fear you.'],
    [2500, 'Legendary Drop Master', 'Your porch is a no-fail zone. Legend.']
  ];
  const STEAL_MSG = {
    tree: ['Stuck in the tree!', 'The tree wanted tacos.'],
    roof: ['Roof delivery... again?!', 'Pizza on the roof!'],
    cat: ['The cat claimed it.', 'Cat: "Mine now."'],
    dog: ['Good boy ate your dinner!', 'Dog says thanks!'],
    pool: ['Splash! Soggy fries.', 'Into the kiddie pool!']
  };
  const WIN_MSG = ['Nailed it!', 'Hot & safe!', 'Chef\'s kiss!', 'Right on the mat!', 'Drop zone!'];

  function titleFor(score) { let t = TITLES[0]; for (const x of TITLES) if (score >= x[0]) t = x; return t; }
  const rand = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  function rr(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }

  class Sound {
    constructor() { this.on = true; this.ctx = null; }
    init() { if (!this.ctx) { try { this.ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { this.on = false; } } if (this.ctx && this.ctx.state === 'suspended') this.ctx.resume(); }
    tone(f1, f2, dur, type = 'sine', vol = 0.15) {
      if (!this.on || !this.ctx) return;
      const c = this.ctx, o = c.createOscillator(), g = c.createGain(), t = c.currentTime;
      o.type = type; o.frequency.setValueAtTime(f1, t); o.frequency.exponentialRampToValueAtTime(Math.max(30, f2), t + dur);
      g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t + dur);
      o.connect(g); g.connect(c.destination); o.start(t); o.stop(t + dur + 0.02);
    }
    win() { this.tone(520, 1040, 0.18, 'triangle'); setTimeout(() => this.tone(780, 1560, 0.2, 'triangle'), 90); }
    bull() { this.win(); setTimeout(() => this.tone(1040, 2080, 0.25, 'square', 0.08), 200); }
    lose() { this.tone(400, 120, 0.35, 'sawtooth', 0.08); }
    toss() { this.tone(300, 600, 0.1, 'sine', 0.06); }
  }

  class Game {
    constructor(root) {
      this.root = root;
      this.canvas = root.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d');
      this.mats = [];
      try { this.mats = JSON.parse(document.getElementById(root.dataset.matsJson).textContent).filter(m => m.available !== false); } catch (e) { this.mats = []; }
      this.matImgs = {};
      this.sound = new Sound();
      this.state = 'start';
      this.keys = {};
      this.pointerX = null;
      this.clouds = [{ x: 40, y: 120, s: 1 }, { x: 230, y: 165, s: 0.8 }, { x: 330, y: 105, s: 0.6 }];
      this.best = 0; try { this.best = +localStorage.getItem('sdm-dash-best') || 0; } catch (e) {}
      this.bind();
      this.resize();
      this.preloadMats();
      this.resetWorld();
      this.last = performance.now();
      requestAnimationFrame(this.loop.bind(this));
    }
    preloadMats() {
      this.mats.forEach(m => {
        const img = new Image();
        img.onerror = () => { if (img.src !== m.img && m.img) img.src = m.img; };
        img.src = m.flat || m.img;
        this.matImgs[m.handle] = img;
      });
    }
    bind() {
      const r = this.root;
      r.querySelectorAll('[data-dash-play]').forEach(b => b.addEventListener('click', () => this.start()));
      r.querySelectorAll('[data-dash-share]').forEach(b => b.addEventListener('click', () => this.share(b)));
      const mute = r.querySelector('[data-dash-mute]');
      if (mute) mute.addEventListener('click', () => { this.sound.on = !this.sound.on; mute.setAttribute('aria-pressed', String(!this.sound.on)); mute.textContent = this.sound.on ? '🔊' : '🔇'; });
      const c = this.canvas;
      const setX = (e) => { const b = c.getBoundingClientRect(); this.pointerX = (e.clientX - b.left) * (W / b.width); };
      c.addEventListener('pointerdown', (e) => { setX(e); c.setPointerCapture && c.setPointerCapture(e.pointerId); });
      c.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse' || e.buttons || e.pressure > 0) setX(e); });
      c.addEventListener('pointerup', () => { if (this.state !== 'play') this.pointerX = null; });
      window.addEventListener('keydown', (e) => {
        if (this.state !== 'play') return;
        if (['ArrowLeft', 'ArrowRight', 'a', 'd', 'A', 'D'].includes(e.key)) { this.keys[e.key.toLowerCase()] = true; this.pointerX = null; e.preventDefault(); }
      });
      window.addEventListener('keyup', (e) => { this.keys[e.key.toLowerCase()] = false; });
      window.addEventListener('resize', () => this.resize());
    }
    resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      this.canvas.width = W * dpr; this.canvas.height = H * dpr;
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    show(name) {
      this.root.querySelectorAll('[data-dash-screen]').forEach(s => { s.hidden = s.dataset.dashScreen !== name; });
      this.root.dataset.state = name;
    }
    resetWorld() {
      this.car = { x: 60, dir: 1, speed: 70 };
      this.score = 0; this.streak = 0; this.time = GAME_SECONDS;
      this.drops = 0; this.landed = 0; this.bulls = 0; this.stolen = 0;
      this.usedMats = [];
      this.particles = []; this.floaters = [];
      this.bag = null; this.pause = 0.6;
      this.obstacles = [];
      this.newMat();
    }
    newMat() {
      const w = clamp(108 - this.drops * 2.5, 74, 108);
      let x = rand(w / 2 + 14, W - w / 2 - 14);
      if (this.mat) { let tries = 0; while (Math.abs(x - this.mat.x) < 70 && tries++ < 10) x = rand(w / 2 + 14, W - w / 2 - 14); }
      const m = this.mats.length ? pick(this.mats) : null;
      this.mat = { x, w, h: w * 0.42, data: m };
    }
    makeObstacles() {
      const n = clamp(1 + Math.floor(this.drops / 3), 1, 3);
      const types = ['tree', 'roof', 'cat', 'dog', 'pool'].sort(() => Math.random() - 0.5).slice(0, n);
      const obs = [];
      const mx = this.mat.x;
      types.forEach(t => {
        const side = Math.random() < 0.5 ? -1 : 1;
        if (t === 'tree') { const cx = side < 0 ? rand(40, 120) : rand(240, 320); obs.push({ t, x: cx, y: rand(250, 330), r: 52, side }); }
        if (t === 'roof') { const left = Math.random() < 0.5; obs.push({ t, left, x: left ? 0 : W, y: rand(170, 230), w: rand(120, 165), h: 46 }); }
        if (t === 'cat') { obs.push({ t, x: rand(40, 320), y: rand(370, 420), vx: rand(55, 95) * (Math.random() < 0.5 ? -1 : 1), r: 22, phase: 0 }); }
        if (t === 'dog') { obs.push({ t, x: rand(30, 330), base: GROUND - 26, y: GROUND - 26, vx: rand(60, 100) * (Math.random() < 0.5 ? -1 : 1), r: 26, jumpT: rand(0, 2), phase: 0 }); }
        if (t === 'pool') {
          let px, tries = 0; do { px = rand(55, W - 55); } while (Math.abs(px - mx) < this.mat.w / 2 + 60 && tries++ < 20);
          if (Math.abs(px - mx) >= this.mat.w / 2 + 50) obs.push({ t, x: px, y: GROUND - 6, w: 96, h: 30 });
        }
      });
      return obs;
    }
    start() {
      this.sound.init();
      this.resetWorld();
      this.state = 'play';
      this.pointerX = null;
      this.show('play');
      this.canvas.focus && this.canvas.focus({ preventScroll: true });
      const fr = this.root.querySelector('.sdm-dash__frame'); if (fr && fr.scrollIntoView) { const b = fr.getBoundingClientRect(); if (b.top < 60 || b.bottom > window.innerHeight) fr.scrollIntoView({ behavior: 'smooth', block: 'end' }); }
    }
    spawnBag() {
      this.drops++;
      this.obstacles = this.makeObstacles();
      const speed = clamp(125 + this.drops * 8, 125, 260);
      this.bag = { x: clamp(this.car.x, 30, W - 30), y: 92, vy: speed, rot: 0, state: 'fall', t: 0 };
      this.pointerX = null;
      this.sound.toss();
    }
    float(text, x, y, color) { this.floaters.push({ text, x: clamp(x, 70, W - 70), y, t: 0, color: color || '#2B2D42' }); }
    confetti(x, y, n) {
      const cols = ['#FFD23F', '#E63946', '#C9B6F2', '#4CC9F0', '#52B788'];
      for (let i = 0; i < n; i++) this.particles.push({ x, y, vx: rand(-160, 160), vy: rand(-320, -80), life: rand(0.7, 1.3), c: pick(cols), s: rand(3, 6), rot: rand(0, 6) });
    }
    finishDrop(kind, obs) {
      const b = this.bag;
      if (kind === 'mat') {
        const acc = 1 - Math.abs(b.x - this.mat.x) / (this.mat.w / 2);
        const bull = acc > 0.72;
        this.streak++;
        const pts = 100 + Math.round(60 * acc) + Math.min(this.streak - 1, 5) * 20 + (bull ? 40 : 0);
        this.score += pts; this.landed++; if (bull) this.bulls++;
        if (this.mat.data && !this.usedMats.includes(this.mat.data.handle)) this.usedMats.push(this.mat.data.handle);
        this.float((bull ? 'BULLSEYE! ' : pick(WIN_MSG) + ' ') + '+' + pts, b.x, b.y - 40, bull ? '#E63946' : '#2B2D42');
        this.confetti(b.x, b.y, bull ? 40 : 22);
        bull ? this.sound.bull() : this.sound.win();
        b.state = 'landed';
      } else if (kind === 'steal') {
        this.streak = 0; this.stolen++;
        this.float(pick(STEAL_MSG[obs.t]), b.x, b.y - 30, '#C1272D');
        this.sound.lose();
        b.state = 'stolen'; b.by = obs;
      } else {
        this.streak = 0;
        this.float(pick(['Lawn delivery...', 'Missed the mat!', 'Left in the grass!']), b.x, b.y - 30, '#6b4f2a');
        this.sound.lose();
        b.state = 'missed';
      }
      this.pause = 0.85;
    }
    update(dt) {
      // ambient
      this.clouds.forEach(c => { c.x += 8 * c.s * dt; if (c.x > W + 60) c.x = -60; });
      this.particles.forEach(p => { p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 600 * dt; p.life -= dt; p.rot += 6 * dt; });
      this.particles = this.particles.filter(p => p.life > 0);
      this.floaters.forEach(f => { f.t += dt; f.y -= 30 * dt; });
      this.floaters = this.floaters.filter(f => f.t < 1.3);
      if (this.state !== 'play') { this.car.x += this.car.dir * 50 * dt; if (this.car.x > W - 50 || this.car.x < 50) this.car.dir *= -1; return; }

      this.time -= dt;
      if (this.time <= 0) { this.time = 0; this.end(); return; }
      // car
      this.car.speed = 70 + this.drops * 4;
      this.car.x += this.car.dir * this.car.speed * dt;
      if (this.car.x > W - 46) { this.car.x = W - 46; this.car.dir = -1; }
      if (this.car.x < 46) { this.car.x = 46; this.car.dir = 1; }
      // obstacles
      this.obstacles.forEach(o => {
        if (o.t === 'cat') { o.x += o.vx * dt; o.phase += dt * 8; if (o.x < 24 || o.x > W - 24) o.vx *= -1; }
        if (o.t === 'dog') {
          o.x += o.vx * dt; o.phase += dt * 10; if (o.x < 28 || o.x > W - 28) o.vx *= -1;
          o.jumpT -= dt; if (o.jumpT < 0) { o.jumpT = rand(1.4, 2.6); o.jv = -330; }
          if (o.jv !== undefined) { o.y += o.jv * dt; o.jv += 900 * dt; if (o.y >= o.base) { o.y = o.base; o.jv = undefined; } }
        }
      });
      if (this.pause > 0) {
        this.pause -= dt;
        if (this.bag && this.bag.state === 'stolen' && this.bag.by && (this.bag.by.t === 'cat' || this.bag.by.t === 'dog')) { this.bag.x = this.bag.by.x; this.bag.y = this.bag.by.y - 18; }
        if (this.pause <= 0) { if (this.bag && this.bag.state !== 'fall') this.newMat(); this.spawnBag(); }
        return;
      }
      const b = this.bag; if (!b || b.state !== 'fall') return;
      b.t += dt;
      // steering
      let vx = 0;
      if (this.keys['arrowleft'] || this.keys['a']) vx = -270;
      else if (this.keys['arrowright'] || this.keys['d']) vx = 270;
      else if (this.pointerX !== null) { const d = this.pointerX - b.x; vx = clamp(d * 7, -330, 330); }
      b.x = clamp(b.x + vx * dt, 16, W - 16);
      b.rot = Math.sin(b.t * 6) * 0.15 + vx / 2400;
      b.y += b.vy * dt;
      // collisions
      for (const o of this.obstacles) {
        let hit = false;
        if (o.t === 'tree' || o.t === 'cat' || o.t === 'dog') hit = Math.hypot(b.x - o.x, b.y - (o.t === 'tree' ? o.y : o.y)) < o.r + 14;
        if (o.t === 'roof') { const x0 = o.left ? 0 : W - o.w, x1 = o.left ? o.w : W; hit = b.x > x0 - 6 && b.x < x1 + 6 && b.y > o.y - 14 && b.y < o.y + o.h; }
        if (o.t === 'pool') hit = b.y > GROUND - 22 && Math.abs(b.x - o.x) < o.w / 2;
        if (hit) { this.finishDrop('steal', o); return; }
      }
      if (b.y >= GROUND - 14) {
        b.y = GROUND - 14;
        const onMat = Math.abs(b.x - this.mat.x) <= this.mat.w / 2 + 4;
        this.finishDrop(onMat ? 'mat' : 'miss');
      }
    }
    end() {
      this.state = 'end';
      if (this.score > this.best) { this.best = this.score; try { localStorage.setItem('sdm-dash-best', String(this.best)); } catch (e) {} }
      const [, title, blurb] = titleFor(this.score);
      this.title = title;
      const r = this.root;
      const set = (sel, v) => r.querySelectorAll(sel).forEach(el => { el.textContent = v; });
      set('[data-dash-final-score]', this.score.toLocaleString());
      set('[data-dash-final-title]', title);
      set('[data-dash-final-blurb]', blurb);
      set('[data-dash-final-stats]', `You landed ${this.landed} of ${this.drops} orders` + (this.bulls ? ` (${this.bulls} bullseye${this.bulls > 1 ? 's' : ''})` : '') + `. Best: ${this.best.toLocaleString()}`);
      this.renderPicks();
      this.show('end');
      this.confetti(W / 2, H / 2, 60);
    }
    renderPicks() {
      const wrap = this.root.querySelector('[data-dash-picks]'); if (!wrap) return;
      const byHandle = Object.fromEntries(this.mats.map(m => [m.handle, m]));
      let picks = this.usedMats.map(h => byHandle[h]).filter(Boolean);
      const rest = this.mats.filter(m => !picks.includes(m)).sort(() => Math.random() - 0.5);
      picks = picks.concat(rest).slice(0, 3);
      wrap.innerHTML = '';
      picks.forEach(m => {
        const a = document.createElement('a');
        a.className = 'sdm-dash__pick'; a.href = m.url;
        const img = document.createElement('img'); img.src = m.img; img.alt = m.title + ' doormat'; img.loading = 'lazy'; img.width = 240; img.height = 135;
        const t = document.createElement('span'); t.className = 'sdm-dash__pick-title'; t.textContent = m.title;
        const p = document.createElement('span'); p.className = 'sdm-dash__pick-price'; p.textContent = m.price;
        a.append(img, t, p); wrap.appendChild(a);
      });
    }
    async share(btn) {
      const url = this.root.dataset.shareUrl || location.href;
      const text = `I scored ${this.score.toLocaleString()} in Delivery Dash and earned "${this.title}"! Can you get the food on the mat? 🍕`;
      try {
        if (navigator.share) { await navigator.share({ title: 'Delivery Dash', text, url }); return; }
        await navigator.clipboard.writeText(text + ' ' + url);
        const old = btn.textContent; btn.textContent = 'Copied! Paste it anywhere'; setTimeout(() => { btn.textContent = old; }, 2200);
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        window.prompt('Copy this and share it:', text + ' ' + url);
      }
    }
    loop(now) {
      const dt = Math.min(0.05, (now - this.last) / 1000); this.last = now;
      this.update(dt); this.draw();
      requestAnimationFrame(this.loop.bind(this));
    }
    /* ---------- drawing ---------- */
    draw() {
      const c = this.ctx;
      c.clearRect(0, 0, W, H);
      // sky
      const g = c.createLinearGradient(0, 0, 0, GROUND); g.addColorStop(0, '#8fd8ff'); g.addColorStop(1, '#e7f7ff');
      c.fillStyle = g; c.fillRect(0, 0, W, GROUND);
      // sun
      c.fillStyle = '#FFD23F'; c.beginPath(); c.arc(310, 150, 26, 0, 7); c.fill();
      this.clouds.forEach(cl => this.cloud(cl.x, cl.y, cl.s));
      // road at top
      c.fillStyle = '#5c5f73'; c.fillRect(0, 40, W, 56);
      c.fillStyle = '#FFD23F'; for (let x = (performance.now() / 30) % 40 - 40; x < W; x += 40) c.fillRect(x, 66, 20, 4);
      c.fillStyle = '#3d3f52'; c.fillRect(0, 94, W, 5);
      // hills & house wall
      c.fillStyle = '#9bd97f'; c.beginPath(); c.ellipse(80, GROUND, 160, 70, 0, Math.PI, 0); c.fill();
      c.fillStyle = '#86cf6a'; c.beginPath(); c.ellipse(300, GROUND, 170, 90, 0, Math.PI, 0); c.fill();
      // fence (cat walkway when present)
      const cat = this.obstacles.find(o => o.t === 'cat');
      if (cat) this.fence(cat.y + 20);
      // ground
      c.fillStyle = '#6cc35a'; c.fillRect(0, GROUND, W, H - GROUND);
      c.fillStyle = '#5aae4a'; for (let x = 6; x < W; x += 18) { c.beginPath(); c.moveTo(x, GROUND); c.lineTo(x + 4, GROUND - 8); c.lineTo(x + 8, GROUND); c.fill(); }
      c.fillStyle = '#d9c3a0'; c.fillRect(0, GROUND + 22, W, 30);
      // obstacles behind
      this.obstacles.forEach(o => { if (o.t === 'tree') this.tree(o); if (o.t === 'roof') this.roof(o); if (o.t === 'pool') this.pool(o); });
      // mat
      this.drawMat();
      this.obstacles.forEach(o => { if (o.t === 'cat') this.catDraw(o); if (o.t === 'dog') this.dog(o); });
      // car
      this.carDraw(this.car.x, 64, this.car.dir);
      // bag
      if (this.bag && !(this.bag.state === 'stolen' && this.bag.by && this.bag.by.t === 'pool')) this.bagDraw(this.bag);
      // guide line
      if (this.state === 'play' && this.bag && this.bag.state === 'fall') {
        c.save(); c.setLineDash([4, 8]); c.strokeStyle = 'rgba(43,45,66,0.25)'; c.lineWidth = 2; c.beginPath(); c.moveTo(this.bag.x, this.bag.y + 20); c.lineTo(this.bag.x, GROUND); c.stroke(); c.restore();
      }
      // particles
      this.particles.forEach(p => { c.save(); c.translate(p.x, p.y); c.rotate(p.rot); c.fillStyle = p.c; c.globalAlpha = clamp(p.life, 0, 1); c.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 1.6); c.restore(); });
      // floaters
      this.floaters.forEach(f => {
        c.save(); c.globalAlpha = clamp(1.3 - f.t, 0, 1); c.font = '700 20px Fredoka, Nunito, system-ui, sans-serif'; c.textAlign = 'center';
        c.lineWidth = 5; c.strokeStyle = '#fff'; c.strokeText(f.text, f.x, f.y); c.fillStyle = f.color; c.fillText(f.text, f.x, f.y); c.restore();
      });
      // HUD
      if (this.state === 'play') this.hud();
    }
    hud() {
      const c = this.ctx;
      c.save();
      c.fillStyle = 'rgba(255,255,255,0.92)'; rr(c, 8, 6, 120, 30, 15); c.fill(); c.strokeStyle = '#2B2D42'; c.lineWidth = 2; c.stroke();
      c.fillStyle = '#2B2D42'; c.font = '700 16px Fredoka, Nunito, system-ui, sans-serif'; c.textAlign = 'left'; c.fillText('Score ' + this.score, 18, 27);
      const tw = 92; c.fillStyle = this.time < 8 ? '#E63946' : 'rgba(255,255,255,0.92)'; rr(c, W - tw - 8, 6, tw, 30, 15); c.fill(); c.stroke();
      c.fillStyle = this.time < 8 ? '#fff' : '#2B2D42'; c.textAlign = 'center'; c.fillText('⏱ ' + Math.ceil(this.time) + 's', W - tw / 2 - 8, 27);
      if (this.streak > 1) { c.fillStyle = '#FFD23F'; rr(c, W / 2 - 46, 6, 92, 30, 15); c.fill(); c.stroke(); c.fillStyle = '#2B2D42'; c.fillText('🔥 x' + this.streak, W / 2, 27); }
      c.restore();
    }
    cloud(x, y, s) { const c = this.ctx; c.fillStyle = 'rgba(255,255,255,0.95)'; c.beginPath(); c.arc(x, y, 18 * s, 0, 7); c.arc(x + 20 * s, y - 8 * s, 22 * s, 0, 7); c.arc(x + 42 * s, y, 17 * s, 0, 7); c.fill(); }
    fence(y) {
      const c = this.ctx; c.fillStyle = '#fff'; c.strokeStyle = '#c9c4b8'; c.lineWidth = 1.5;
      for (let x = 4; x < W; x += 22) { c.beginPath(); c.moveTo(x, y + 60); c.lineTo(x, y + 4); c.lineTo(x + 7, y - 4); c.lineTo(x + 14, y + 4); c.lineTo(x + 14, y + 60); c.closePath(); c.fill(); c.stroke(); }
      c.fillRect(0, y + 14, W, 7); c.fillRect(0, y + 40, W, 7);
    }
    carDraw(x, y, dir) {
      const c = this.ctx; c.save(); c.translate(x, y); c.scale(dir, 1);
      c.fillStyle = 'rgba(0,0,0,0.2)'; c.beginPath(); c.ellipse(0, 22, 40, 5, 0, 0, 7); c.fill();
      c.fillStyle = '#E63946'; rr(c, -40, -6, 80, 26, 10); c.fill();
      c.fillStyle = '#C1272D'; rr(c, -26, -24, 46, 22, 10); c.fill();
      c.fillStyle = '#bfe9ff'; rr(c, -20, -20, 34, 15, 6); c.fill();
      // driver: red cap, smile
      c.fillStyle = '#f2c29b'; c.beginPath(); c.arc(4, -10, 7, 0, 7); c.fill();
      c.fillStyle = '#E63946'; c.beginPath(); c.arc(4, -13, 7, Math.PI, 0); c.fill(); c.fillRect(4, -14, 11, 3);
      c.strokeStyle = '#2B2D42'; c.lineWidth = 1.2; c.beginPath(); c.arc(6, -9, 3, 0.2, 2.6); c.stroke();
      c.fillStyle = '#FFD23F'; c.fillRect(30, 0, 8, 6);
      c.fillStyle = '#2B2D42'; [-24, 24].forEach(wx => { c.beginPath(); c.arc(wx, 20, 9, 0, 7); c.fill(); c.fillStyle = '#ddd'; c.beginPath(); c.arc(wx, 20, 3.5, 0, 7); c.fill(); c.fillStyle = '#2B2D42'; });
      c.restore();
    }
    bagDraw(b) {
      const c = this.ctx; c.save(); c.translate(b.x, b.y); c.rotate(b.rot || 0);
      c.fillStyle = '#c98f4f'; c.beginPath(); c.moveTo(-15, -16); c.lineTo(15, -16); c.lineTo(17, 16); c.lineTo(-17, 16); c.closePath(); c.fill();
      c.strokeStyle = '#8a5a2b'; c.lineWidth = 2; c.stroke();
      c.fillStyle = '#b07a3f'; c.fillRect(-15, -16, 30, 6);
      c.strokeStyle = '#8a5a2b'; c.beginPath(); c.arc(0, -16, 7, Math.PI, 0); c.stroke();
      c.fillStyle = '#2B2D42'; c.beginPath(); c.arc(-6, 0, 2.2, 0, 7); c.arc(6, 0, 2.2, 0, 7); c.fill();
      c.strokeStyle = '#2B2D42'; c.lineWidth = 1.6; c.beginPath(); c.arc(0, 3, 5, 0.2, Math.PI - 0.2); c.stroke();
      c.fillStyle = '#ff8fa3'; c.globalAlpha = 0.7; c.beginPath(); c.arc(-10, 5, 2.5, 0, 7); c.arc(10, 5, 2.5, 0, 7); c.fill();
      // steam
      if (b.state === 'fall') { c.globalAlpha = 0.6; c.strokeStyle = '#fff'; c.lineWidth = 2; c.beginPath(); c.moveTo(-4, -26); c.quadraticCurveTo(-8, -32, -4, -38); c.moveTo(4, -26); c.quadraticCurveTo(8, -32, 4, -38); c.stroke(); }
      c.restore();
    }
    drawMat() {
      const c = this.ctx, m = this.mat; if (!m) return;
      const y = GROUND + 4, h = 24, topW = m.w * 0.86;
      c.save();
      c.fillStyle = 'rgba(0,0,0,0.22)'; c.beginPath(); c.ellipse(m.x, y + h + 2, m.w / 2 + 4, 6, 0, 0, 7); c.fill();
      const img = m.data && this.matImgs[m.data.handle];
      c.beginPath(); c.moveTo(m.x - topW / 2, y); c.lineTo(m.x + topW / 2, y); c.lineTo(m.x + m.w / 2, y + h); c.lineTo(m.x - m.w / 2, y + h); c.closePath();
      c.fillStyle = '#2B2D42'; c.fill();
      if (img && img.complete && img.naturalWidth) {
        const N = 12;
        for (let i = 0; i < N; i++) {
          const t = i / N, w = topW + (m.w - topW) * t;
          c.drawImage(img, 0, img.naturalHeight * t, img.naturalWidth, img.naturalHeight / N + 1, m.x - w / 2 + 2, y + h * t + 1, w - 4, h / N + 0.6);
        }
      } else {
        c.fillStyle = '#FFD23F'; c.fill(); c.fillStyle = '#2B2D42'; c.font = '700 9px system-ui'; c.textAlign = 'center'; c.fillText('PLACE FOOD HERE', m.x, y + 15);
      }
      c.restore();
      // bouncing arrow
      if (this.state === 'play') {
        const by = GROUND - 30 + Math.sin(performance.now() / 180) * 5;
        c.save(); c.fillStyle = '#E63946'; c.strokeStyle = '#fff'; c.lineWidth = 2;
        c.beginPath(); c.moveTo(m.x - 9, by - 12); c.lineTo(m.x + 9, by - 12); c.lineTo(m.x + 9, by - 2); c.lineTo(m.x + 15, by - 2); c.lineTo(m.x, by + 10); c.lineTo(m.x - 15, by - 2); c.lineTo(m.x - 9, by - 2); c.closePath(); c.fill(); c.stroke();
        c.restore();
      }
    }
    tree(o) {
      const c = this.ctx; c.save();
      c.fillStyle = '#8a5a2b'; c.fillRect(o.x - 10, o.y, 20, GROUND - o.y);
      c.strokeStyle = '#8a5a2b'; c.lineWidth = 7; c.beginPath(); c.moveTo(o.x, o.y + 40); c.lineTo(o.x + 26 * (o.side || 1), o.y + 10); c.stroke();
      c.fillStyle = '#3fa34d'; c.beginPath(); c.arc(o.x, o.y - 6, o.r, 0, 7); c.arc(o.x - 32, o.y + 14, 30, 0, 7); c.arc(o.x + 32, o.y + 12, 30, 0, 7); c.fill();
      c.fillStyle = '#2e8f3e'; c.beginPath(); c.arc(o.x + 14, o.y + 4, 22, 0, 7); c.fill();
      // sneaky eyes
      c.fillStyle = '#fff'; c.beginPath(); c.arc(o.x - 12, o.y - 10, 8, 0, 7); c.arc(o.x + 12, o.y - 10, 8, 0, 7); c.fill();
      const look = this.bag ? clamp((this.bag.x - o.x) / 60, -1, 1) * 3 : 0;
      c.fillStyle = '#2B2D42'; c.beginPath(); c.arc(o.x - 12 + look, o.y - 9, 3.5, 0, 7); c.arc(o.x + 12 + look, o.y - 9, 3.5, 0, 7); c.fill();
      c.strokeStyle = '#2B2D42'; c.lineWidth = 2; c.beginPath(); c.arc(o.x, o.y + 6, 8, 0.1, Math.PI - 0.1); c.stroke();
      if (this.bag && this.bag.state === 'stolen' && this.bag.by === o) { c.restore(); return; }
      c.restore();
    }
    roof(o) {
      const c = this.ctx; c.save();
      const x0 = o.left ? 0 : W - o.w, x1 = o.left ? o.w : W;
      c.fillStyle = '#7b5cc4'; c.fillRect(x0, o.y + o.h, x1 - x0, 60);
      c.fillStyle = '#E63946'; c.beginPath();
      if (o.left) { c.moveTo(0, o.y); c.lineTo(o.w - 20, o.y); c.lineTo(o.w + 8, o.y + o.h); c.lineTo(0, o.y + o.h); }
      else { c.moveTo(W, o.y); c.lineTo(W - o.w + 20, o.y); c.lineTo(W - o.w - 8, o.y + o.h); c.lineTo(W, o.y + o.h); }
      c.closePath(); c.fill(); c.strokeStyle = '#2B2D42'; c.lineWidth = 2; c.stroke();
      c.strokeStyle = 'rgba(0,0,0,0.25)'; c.lineWidth = 1.5;
      for (let yy = o.y + 11; yy < o.y + o.h; yy += 11) { c.beginPath(); c.moveTo(x0, yy); c.lineTo(x1, yy); c.stroke(); }
      const chx = o.left ? o.w * 0.4 : W - o.w * 0.4 - 18; c.fillStyle = '#C1272D'; c.fillRect(chx, o.y - 22, 18, 24);
      c.restore();
    }
    pool(o) {
      const c = this.ctx; c.save();
      c.fillStyle = '#E63946'; c.beginPath(); c.ellipse(o.x, o.y, o.w / 2, o.h / 2, 0, 0, 7); c.fill();
      c.fillStyle = '#4CC9F0'; c.beginPath(); c.ellipse(o.x, o.y - 2, o.w / 2 - 7, o.h / 2 - 6, 0, 0, 7); c.fill();
      c.fillStyle = '#fff'; c.globalAlpha = 0.6; c.beginPath(); c.ellipse(o.x - 14, o.y - 5, 12, 3, 0, 0, 7); c.fill(); c.globalAlpha = 1;
      // duck
      const dx = o.x + 18 + Math.sin(performance.now() / 400) * 6, dy = o.y - 6;
      c.fillStyle = '#FFD23F'; c.beginPath(); c.ellipse(dx, dy, 9, 6, 0, 0, 7); c.arc(dx + 6, dy - 7, 5, 0, 7); c.fill();
      c.fillStyle = '#f77f00'; c.beginPath(); c.moveTo(dx + 10, dy - 8); c.lineTo(dx + 16, dy - 6); c.lineTo(dx + 10, dy - 5); c.fill();
      c.fillStyle = '#2B2D42'; c.beginPath(); c.arc(dx + 7, dy - 8, 1.2, 0, 7); c.fill();
      if (this.bag && this.bag.state === 'stolen' && this.bag.by === o) {
        c.fillStyle = '#c98f4f'; c.globalAlpha = 0.8; c.fillRect(o.x - 12, o.y - 10, 24, 10);
        c.strokeStyle = '#fff'; c.lineWidth = 2; c.globalAlpha = 1;
        for (let i = 0; i < 5; i++) { c.beginPath(); c.arc(o.x + (i - 2) * 10, o.y - 14 - (i % 2) * 6, 3, 0, 7); c.stroke(); }
      }
      c.restore();
    }
    catDraw(o) {
      const c = this.ctx; c.save(); c.translate(o.x, o.y); c.scale(o.vx < 0 ? -1 : 1, 1);
      const bob = Math.sin(o.phase) * 1.5;
      c.fillStyle = '#f4a259';
      c.beginPath(); c.ellipse(-4, 8 + bob, 20, 11, 0, 0, 7); c.fill();
      c.strokeStyle = '#f4a259'; c.lineWidth = 5; c.lineCap = 'round'; c.beginPath(); c.moveTo(-22, 6); c.quadraticCurveTo(-34, -6 + Math.sin(o.phase / 2) * 6, -26, -18); c.stroke();
      c.beginPath(); c.arc(14, -4 + bob, 12, 0, 7); c.fill();
      c.beginPath(); c.moveTo(5, -12 + bob); c.lineTo(8, -24 + bob); c.lineTo(13, -14 + bob); c.moveTo(16, -14 + bob); c.lineTo(22, -23 + bob); c.lineTo(24, -10 + bob); c.fill();
      c.strokeStyle = '#d4782f'; c.lineWidth = 2; for (let i = -12; i < 8; i += 7) { c.beginPath(); c.moveTo(i, 0 + bob); c.lineTo(i + 2, 6 + bob); c.stroke(); }
      c.fillStyle = '#2B2D42'; c.beginPath(); c.arc(11, -6 + bob, 1.8, 0, 7); c.arc(19, -6 + bob, 1.8, 0, 7); c.fill();
      c.strokeStyle = '#2B2D42'; c.lineWidth = 1; c.beginPath(); c.moveTo(22, -1 + bob); c.lineTo(32, -3 + bob); c.moveTo(22, 1 + bob); c.lineTo(32, 2 + bob); c.stroke();
      c.fillStyle = '#d4782f'; [-16, -4, 6].forEach((lx, i) => c.fillRect(lx, 16 + bob + (i % 2 ? Math.sin(o.phase) * 2 : -Math.sin(o.phase) * 2), 4, 6));
      c.restore();
    }
    dog(o) {
      const c = this.ctx; c.save(); c.translate(o.x, o.y); c.scale(o.vx < 0 ? -1 : 1, 1);
      c.fillStyle = 'rgba(0,0,0,0.18)'; c.restore(); c.save();
      c.fillStyle = 'rgba(0,0,0,0.18)'; c.beginPath(); c.ellipse(o.x, GROUND + 2, 22, 4, 0, 0, 7); c.fill(); c.restore();
      c.save(); c.translate(o.x, o.y); c.scale(o.vx < 0 ? -1 : 1, 1);
      const leg = Math.sin(o.phase) * 4;
      c.fillStyle = '#e9b872';
      c.beginPath(); c.ellipse(-4, 6, 24, 13, 0, 0, 7); c.fill();
      c.fillRect(-22, 12, 6, 14 + leg); c.fillRect(-8, 12, 6, 14 - leg); c.fillRect(6, 12, 6, 14 + leg); c.fillRect(14, 12, 6, 14 - leg);
      c.strokeStyle = '#e9b872'; c.lineWidth = 5; c.lineCap = 'round'; c.beginPath(); c.moveTo(-26, 2); c.lineTo(-36, -8 + Math.sin(o.phase * 2) * 5); c.stroke();
      c.beginPath(); c.arc(20, -8, 13, 0, 7); c.fill();
      c.beginPath(); c.ellipse(32, -4, 8, 6, 0, 0, 7); c.fill();
      c.fillStyle = '#c98f4f'; c.beginPath(); c.ellipse(12, -6, 5, 11, 0.3, 0, 7); c.fill();
      c.fillStyle = '#2B2D42'; c.beginPath(); c.arc(24, -11, 2, 0, 7); c.fill(); c.beginPath(); c.arc(39, -6, 3, 0, 7); c.fill();
      c.fillStyle = '#ff6b8b'; c.beginPath(); c.ellipse(33, 3, 3, 5, 0, 0, 7); c.fill();
      c.fillStyle = '#E63946'; c.fillRect(10, 0, 16, 4);
      c.restore();
    }
  }

  function boot() { document.querySelectorAll('[data-sdm-dash]').forEach(el => { if (!el.__sdm) el.__sdm = new Game(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
